module.exports = __webpack_public_path__ + "img/rock-big-06.de02abad.png";